import React, { useRef } from "react";
import ReactDom from "react-dom";
import ContestIntro from "../ContestIntro/ContestIntro";

export default function ModalPopUp({ data, setShowModal }) {
  const modalRef = useRef();

  const closeModal = (e) => {
    if (e.target === modalRef.current) {
      setShowModal(false);
    }
  };

  return ReactDom.createPortal(
    <div
      className="container min-w-full z-50 lg:mt-0 mt-44 "
      ref={modalRef}
      onClick={closeModal}
    >
      <div className="modal w-2/3">
        <ContestIntro contest={data} />
        <button className="bg-blue-600" onClick={() => setShowModal(false)}>
          x
        </button>
      </div>
    </div>,
    document.getElementById("portal")
  );
}
